/* eslint-disable max-len */
import api, {privateApi} from 'utils/api'

export const getStationList = async (param: any) => await api.get(`/cps/v1/suggestive-country-code?input=${param}`)

export const getStationListNew = async (param: any) =>
    await api.get(`/cps/v1/suggestive-country-code?input=${param[0]}&station=${param[1]}`)

export const getFlightList = async (payload: any) => await privateApi.post('/cps/v1/availability-price', payload)

export const getCarrierList = async (payload: any) => await api.post('/cps/v1/carrier', payload)

export const getCarrierLogos = async () => await api.get('/cps/v1/carrier-logo')

export const getProductList = async () => await api.get('/cps/v1/product')

export const getDefaultAccount = async (payload: any) => await api.post('/cps/v1/defaultAccount', payload)

export const getPhoneCodeList = async () => await api.get('/cps/v1/phone-country-code')

export const getBranchDetails = async (param: string) => await api.get(`/cps/v1/getBranchDetails?input=${param}`)

export const isAccountExists = async (param: string) => await api.get(`/cps/v1/isAccountExists?input=${param}`)

export const getAdminEmails = async (param: string) => await api.get(`/cps/v1/getAdminEmail?branchId=${param}`)

export const getAllCarrierList = async () => await api.get('/cps/v1/all-carriers')

export const getStatesByCountry = async (param: any) =>
    await api.get(`/cps/v1/get-states-by-country-code?input=${param}`)

export const getAllCountryCodeList = async (param: any) => await api.get(`/cps/v1/all-country-code?${param}`)

export const getEmbargoedCountryYN = async () =>
    await api.get('/cps/v1/isEmbargoedCountry', {
        headers: {
            Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7'
        }
    })

export const getAllCountriesList = async () => await api.get('/cps/v1/get-countries')

export const getAllContinentsList = async () => await api.get('/cps/v1/get-continents')

export const getAllRegionsList = async () => await api.get('/cps/v1/get-regions')

export const getCommodityList = async (param: any) =>
    await privateApi.get(`/cps/v1/booking-common-service/suggestive-commodity-code?input=${param}`)

export const getLatestCommodities = async (param: any) => {
    const parameters = new URLSearchParams(param).toString()
    return await privateApi.get(`/cps/v1/marketplace-commodity?${parameters}`)
}
